
import { v4 as uuidv4 } from "uuid";
import { FloatingFeature } from "@models";
import { ASIFeature } from "@dndModels/feature/ASIFeature";

/**
 * This is a type of Feature that increases an Ability Score. 
 *  
 * It comes in a few varieties:
 * 
 * There are the ones you get as Class Features at numerous levels. 
 * Those ones give you the choice of taking 
 * two ASIs on any Ability Score,
 * or one Feat.
 * 
 * There are also the ones you get in Feats, which either automatically
 * increase a single Ability Score by one, or give you a choice, 
 * usually from three options.
 * 
 * There are also racial ones, which itself comes in a number of 
 * varieties.  
 * 
 * Human gets +1 to all, but that can easily be represented by +1 to 
 * each.
 * 
 * V Human gets a +1 to 2 choices, but they can't be the same one.
 * 
 * Half Elf gets +2 to Charisma, 
 * and +1 to 2 choices that can't be Charisma and can't be the same.
 * 
 * Most others don't give choices, but give some combination of +2 to one
 * and +1 to a different one.
 * 
 * 
 */
export class ASIBaseFeature extends FloatingFeature {
  feat_option = false; // Can they take a Feat instead?
  override_score = false;
  choices: ASIChoice[] = [new ASIChoice()];
  allow_duplicates = false;

  constructor(obj?: any) {
    super(obj);
    if (obj) {
      // if (this._id === "6285282c79846706802c9b20") {
      //   debugger;
      // }
      this.feat_option = obj.feat_option ? obj.feat_option : false;
      this.override_score = obj.override_score ? obj.override_score : false;
      if (obj.choices) {
        this.choices = obj.choices.map((o: any) => new ASIChoice(o));
      } else if (obj.asi_features && obj.asi_features.length > 0) {
        const choice = new ASIChoice();
        obj.asi_features.forEach((o: any) => {
          const asi_feature = new ASIFeature(o);
          // asi_feature.id = this.asi_features.length;
          choice.asi_features.push(asi_feature);
        });
        this.choices = [];
        this.choices.push(choice);
      }
      this.allow_duplicates = obj.allow_duplicates ? obj.allow_duplicates : false;
    }
  }

  // load(obj: any): void {
  //   super.load(obj);
  //   if (obj) {
  //     // if (this._id === "6285282c79846706802c9b20") {
  //     //   debugger;
  //     // }
  //     this.feat_option = obj.feat_option ? obj.feat_option : false;
  //     this.override_score = obj.override_score ? obj.override_score : false;
  //     if (obj.choices) {
  //       this.choices = obj.choices.map((o: any) => new ASIChoice(o));
  //     } else if (obj.asi_features && obj.asi_features.length > 0) {
  //       const choice = new ASIChoice();
  //       obj.asi_features.forEach((o: any) => {
  //         const asi_feature = new ASIFeature(o);
  //         // asi_feature.id = this.asi_features.length;
  //         choice.asi_features.push(asi_feature);
  //       });
  //       this.choices = [];
  //       this.choices.push(choice);
  //     }
  //     this.allow_duplicates = obj.allow_duplicates ? obj.allow_duplicates : false;
  //   }
  // }

  get asi_features(): ASIFeature[] {
    return this.choices.length === 1 ? this.choices[0].asi_features : [];
  }

  toDBObj(): any {
    const db_obj = super.toDBObj();
    return {
      ...db_obj,
      feat_option: this.feat_option,
      override_score: this.override_score,
      choices: this.choices.map(o => o.toDBObj()),
      allow_duplicates: this.allow_duplicates
    };
  }
  
  copy(copyMe: FloatingFeature, drop_ids = false): void {
    super.copy(copyMe, drop_ids);
    if (copyMe instanceof ASIBaseFeature) {
      this.safe_copy(copyMe);
    }
  }

  safe_copy(copyMe: ASIBaseFeature) {
    this.feat_option = copyMe.feat_option;
    this.override_score = copyMe.override_score;
    this.choices = copyMe.choices.map(o => o.clone());
    this.allow_duplicates = copyMe.allow_duplicates;
  }

  clone(drop_ids = false): ASIBaseFeature {
    const new_obj = new ASIBaseFeature();
    new_obj.copy(this, drop_ids);
    return new_obj;
  }
}

export class ASIChoice {
  true_id = "";
  label = "";
  asi_features: ASIFeature[] = [];

  constructor(obj?: any) {
    this.true_id = obj && obj.true_id ? obj.true_id : uuidv4().toString();
    if (obj) {
      this.label = obj.label ? obj.label : "";
      if (obj.asi_features && obj.asi_features.length > 0) {
        obj.asi_features.forEach((o: any) => {
          const asi_feature = new ASIFeature(o);
          // asi_feature.id = this.asi_features.length;
          this.asi_features.push(asi_feature);
        });
      }
    }
  }

  toDBObj(): any {
    return {
      true_id: this.true_id,
      label: this.label,
      asi_features: this.asi_features.map(o => o.toDBObj()),
    };
  }
  
  copy(copyMe: ASIChoice, drop_ids = false): void {
    if (!drop_ids) {
      this.true_id = copyMe.true_id;
    }
    this.label = copyMe.label;
    this.asi_features = copyMe.asi_features.map(o => o.clone());
  }

  clone(drop_ids = false): ASIChoice {
    const new_obj = new ASIChoice();
    new_obj.copy(this, drop_ids);
    return new_obj;
  }
}